import { styled } from "@mui/material";

import { Column } from "../layout";

export const ErrorPage = styled(Column)(({ theme }) => ({
  gap: theme.spacing(5),
  padding: theme.spacing(5),
}));

export const MessageBox = styled(Column)(({ theme }) => ({
  alignItems: "center",
  borderColor: theme.palette.grey[400],
  borderStyle: "solid",
  borderWidth: "1px 0",
  gap: theme.spacing(5),
  padding: theme.spacing(5),
}));

export const MessageContent = styled(Column)(({ theme }) => ({
  gap: theme.spacing(4),
}));

export const StackTrace = styled(Column)(({ theme }) => ({
  gap: theme.spacing(2),
}));
